import { request as queryRequest } from './reducers/query';
import { request as createRequest } from './reducers/create';
import { request as saveRequest } from './reducers/save';
import { request as moveRequest } from './reducers/move';
import { request as moveListRequest } from './reducers/move-list';

// eslint-disable-next-line import/no-default-export
export default {
    COMPETITIONS_QUERY_REQUEST: queryRequest,
    COMPETITIONS_CREATE_REQUEST: createRequest,
    COMPETITIONS_SAVE_REQUEST: saveRequest,
    COMPETITIONS_MOVE_REQUEST: moveRequest,
    COMPETITIONS_LIST_MOVE_REQUEST: moveListRequest,
};
